export default {
  SET_SUBSCRIPTION_PLAN (state, plan) {
    state.active_plan = plan
  },
  SET_CURRENCY (state, currency) {
    state.currency = currency
  },
  SET_ROLE (state, role) {
    state.role = role
  },
  SET_EMAIL (state, email) {
    state.email = email
  },
  SET_IP_DATA (state, ipData) {
    state.ip_data = ipData
  },
  SET_PERMISSIONS (state, permissions) {
    if (permissions !== undefined) {
      state.permissions = permissions
    }
  },
  SET_WEBINAR_FOLLOW_UP_TEXT (state, webinarFollowUpText) {
    state.webinarFollowUpText = webinarFollowUpText
  },
  SET_ADMIN_REMINDER_TEXT (state, adminReminderText) {
    state.adminReminderText = adminReminderText
  },
  SET_REMINDER_TEXT (state, reminderText) {
    state.reminderText = reminderText
  },
  SET_REMINDERS_COUNT (state, remindersCount) {
    state.remindersCount = remindersCount
  },
  SET_NEW_FLOW_DOMAIN (state, newFlowDomain) {
    state.newFlowDomain = newFlowDomain
  },
  SET_USER (state, user) {
    if (user.id !== undefined) {
      state.id = user.id
    }
    if (user.email !== undefined) {
      state.email = user.email
    }
    if (user.fullname !== undefined) {
      state.fullname = user.fullname
    }
    if (user.work_in !== undefined) {
      state.work_in = user.work_in
    }
    if (user.role !== undefined) {
      state.role = user.role
    }
    if (user.status !== undefined) {
      state.status = user.status
    }
    if (user.signup !== undefined) {
      state.signup = user.signup
    }
    if (user.activated !== undefined) {
      state.activated = user.activated
    }
    if (user.last_login !== undefined) {
      state.last_login = user.last_login
    }
    if (user.credits !== undefined) {
      state.credits = user.credits
    }
    if (user.keywords_count !== undefined) {
      state.keywords_count = user.keywords_count
    }
    if (user.projects_count !== undefined) {
      state.projects_count = user.projects_count
    }
    if (user.reports_count !== undefined) {
      state.reports_count = user.reports_count
    }
    if (user.links_count !== undefined) {
      state.links_count = user.links_count
    }
    // if (user.permissions !== undefined) {
    //   state.permissions = user.permissions
    // }
    if (user.overridden_permissions !== undefined) {
      state.overridden_permissions = user.overridden_permissions
    }
    if (user.projects !== undefined) {
      state.projects = user.projects
    }
    if (user.first_day !== undefined) {
      state.first_day_of_week = user.first_day
    }
    if (user.package_id !== undefined) {
      state.package_id = user.package_id
    }
    if (user.package_expired_at !== undefined) {
      state.package_expired_at = user.package_expired_at
    }
    if (user.keywords_limit !== undefined) {
      state.keywords_limit = user.keywords_limit
    }
    if (user.projects_limit !== undefined) {
      state.projects_limit = user.projects_limit
    }
    if (user.links_limit !== undefined) {
      state.links_limit = user.links_limit
    }
    if (user.reports_limit !== undefined) {
      state.reports_limit = user.reports_limit
    }

    if (user.keywords_limit !== undefined) {
      state.keywords_count_count = user.keywords_limit
    }
    if (user.projects_limit !== undefined) {
      state.projects_count_limit = user.projects_limit
    }
    if (user.links_limit !== undefined) {
      state.links_count_limit = user.links_limit
    }
    if (user.reports_limit !== undefined) {
      state.reports_count_limit = user.reports_limit
    }

    if (user.history_starts_at !== undefined) {
      state.history_starts_at = user.history_starts_at
    }
    if (user.first_day !== undefined) {
      state.first_day_of_week = user.first_day
    }
    if (user.made_reports !== undefined) {
      state.made_reports = user.made_reports
    }
    if (user.currency !== undefined) {
      state.currency = user.currency
    }
    // if (user.is_ten_club_member !== undefined) {
    //   state.is_ten_club_member = user.is_ten_club_member
    // }
    if (user.ten_club_reports !== undefined) {
      state.ten_club_reports = user.ten_club_reports || []
    }
    if (user.subscription_renew !== undefined) {
      state.subscription_renew = user.subscription_renew
    }
    if (user.is_trial_available !== undefined) {
      state.is_trial_available = user.is_trial_available
    }
    if (user.is_trial !== undefined) {
      state.is_trial = user.is_trial
    }
    if (user.package_status !== undefined) {
      state.package_status = user.package_status
    }
    if (user.coupon !== undefined) {
      state.coupon = user.coupon
    }
    if (user.is_affiliate !== undefined) {
      state.is_affiliate = user.is_affiliate
    }
    if (user.package_type !== undefined) {
      state.package_type = user.package_type
    }
    if (user.package_display_name !== undefined) {
      state.package_display_name = user.package_display_name
    }
    if (user.extra_limits !== undefined) {
      state.extra_limits = user.extra_limits
    }
    if (user.limits !== undefined) {
      state.limits = user.limits
    }
    if (user.phone_number !== undefined) {
      state.phone_number = user.phone_number
    }
    if (user.finished_steps !== undefined) {
      state.finished_steps = user.finished_steps
    }
    if (user.package_level !== undefined) {
      state.package_level = user.package_level
    }
    if (user.country_code !== undefined) {
      state.country_code = user.country_code
    }
    if (user.affiliate_name !== undefined) {
      state.affiliate_name = user.affiliate_name
    }
    if (user.workspaces_count !== undefined) {
      state.workspaces_count = user.workspaces_count
    }
    if (user.workspaces_limit !== undefined) {
      state.workspaces_limit = user.workspaces_limit
    }
    if (user.competitors_workspaces_count !== undefined) {
      state.competitors_workspaces_count = user.competitors_workspaces_count
    }
    if (user.competitors_workspaces_limit !== undefined) {
      state.competitors_workspaces_limit = user.competitors_workspaces_limit
    }
    if (user.urls_traffic_count !== undefined) {
      state.urls_traffic_count = user.urls_traffic_count
    }
    if (user.urls_traffic_limit !== undefined) {
      state.urls_traffic_limit = user.urls_traffic_limit
    }
    if (user.global_reports_count !== undefined) {
      state.global_reports_count = user.global_reports_count
    }
    if (user.global_reports_limit !== undefined) {
      state.global_reports_limit = user.global_reports_limit
    }
    if (user.made_global_reports !== undefined) {
      state.made_global_reports = user.made_global_reports
    }
    if (user.user_type !== undefined) {
      state.user_type = user.user_type
    }
    if (user.events !== undefined) {
      state.events = user.events
    }
  },
  CLEAR_USER (state) {
    state.id = null
    state.email = null
    state.fullname = null
    state.phone_number = null
    state.work_in = null
    state.role = null
    state.status = null
    state.signup = null
    state.activated = null
    state.last_login = null
    state.credits = null
    state.keywords_count = 0
    state.projects_count = 0
    state.reports_count = 0
    state.links_count = 0
    state.permissions = null
    state.overridden_permissions = null
    state.projects = null
    state.first_day_of_week = 0
    state.package_id = 0
    state.package_expired_at = ''
    state.keywords_limit = 0
    state.projects_limit = 0
    state.links_limit = 0
    state.reports_limit = 0
    state.keywords_count_limit = 0
    state.projects_count_limit = 0
    state.links_count_limit = 0
    state.reports_count_limit = 0
    state.history_starts_at = ''
    state.made_reports = 0
    state.subscription_renew = null
    state.ten_club_reports = []
    state.currency = 1
    state.is_trial_available = null
    state.is_trial = null
    state.package_status = null
    state.coupon = null
    state.active_plan = null
    state.is_affiliate = null
    state.package_display_name = ''
    state.package_type = null
    state.limits = null
    state.extra_limits = null
    state.finished_steps = []
    state.package_level = 0
    state.country_code = ''
    state.affiliate_name = ''
    state.workspaces_count = 0
    state.workspaces_limit = 0
    state.competitors_workspaces_count = 0
    state.competitors_workspaces_limit = 0
    state.urls_traffic_count = 0
    state.urls_traffic_limit = 0
    state.adminReminderText = ''
    state.reminderText = ''
    state.remindersCount = 0
    state.global_reports_count = 0
    state.global_reports_limit = 0
    state.made_global_reports = 0
    state.new_flow_domain = null
    state.user_type = null
    state.events = []
  }
}



// WEBPACK FOOTER //
// ./src/store/user/mutations.js